// @ts-check
/**
 * #1947 — wiens gebeurtenis is het? Een akte noemt meer mensen dan de hoofdpersoon. Wie er alleen op
 * vermeld staat (vader en moeder bij een geboorte, de weduwe bij een overlijden, een getuige bij een
 * huwelijk) houdt die deelname, maar het is niet zijn eigen levensfeit. Behandelde Pecktree het wel
 * zo, dan zette een gewijzigde geboortedatum van de moeder ook de geboorte van haar kinderen om
 * (Emma, 30-10) en las het rapport de geboorte van zoon Jan als die van haar.
 *
 * Eén regel per soort akte (besluit Twan 30-10, V1 A), gelezen door de server (personenlijst,
 * gebeurtenissen per persoon) en de app (store, huwelijk bij een paar):
 * - vitaal: alleen de hoofdpersoon;
 * - paar (huwelijk en verwanten): de partners;
 * - overige akten: hoofdpersoon, partner en getuige (#1924 B3).
 * Een deelname zonder rol is een eigen gebeurtenis (oude gegevens, handmatige invoer).
 */
export const VITALE_TYPES = [
  'birth',
  'christening',
  'baptism',
  'adult_christening',
  'death',
  'burial',
  'cremation',
];

export const PAAR_TYPES = [
  'marriage',
  'marriage_bann',
  'marriage_contract',
  'marriage_license',
  'marriage_settlement',
  'engagement',
  'divorce',
  'divorce_filed',
  'annulment',
  'family_other',
];

const HOOFDPERSOON = ['', 'subject', 'principal', 'primary'];
const PARTNER = ['partner', 'spouse', 'bride', 'groom'];

/** De rollen die bij dit soort akte een eigen gebeurtenis maken. @param {string | null | undefined} type */
export function eigenRollen(type) {
  const t = String(type || '');
  if (VITALE_TYPES.includes(t)) return HOOFDPERSOON;
  if (PAAR_TYPES.includes(t)) return [...HOOFDPERSOON, ...PARTNER];
  return [...HOOFDPERSOON, ...PARTNER, 'witness'];
}

/**
 * @param {string | null | undefined} type
 * @param {string | null | undefined} rol
 */
export const isEigenDeelname = (type, rol) =>
  eigenRollen(type).includes(String(rol || '').toLowerCase());

const lijst = (/** @type {string[]} */ w) => w.map((x) => `'${x}'`).join(', ');

/**
 * Dezelfde regel als SQL-expressie. Kolomnamen komen uit de code, nooit uit invoer; de waarden
 * zijn de vaste lijsten hierboven.
 * @param {string} typeKolom
 * @param {string} rolKolom
 */
export function eigenDeelnameSql(typeKolom, rolKolom) {
  const rol = `LOWER(COALESCE(${rolKolom}, ''))`;
  return `(CASE
    WHEN ${typeKolom} IN (${lijst(VITALE_TYPES)}) THEN ${rol} IN (${lijst(eigenRollen('birth'))})
    WHEN ${typeKolom} IN (${lijst(PAAR_TYPES)}) THEN ${rol} IN (${lijst(eigenRollen('marriage'))})
    ELSE ${rol} IN (${lijst(eigenRollen('other'))})
  END)`;
}
